import { render, staticRenderFns } from "./DvPopover.vue?vue&type=template&id=6ceb92ed&scoped=true&"
import script from "./DvPopover.vue?vue&type=script&lang=ts&"
export * from "./DvPopover.vue?vue&type=script&lang=ts&"
import style0 from "./DvPopover.vue?vue&type=style&index=0&id=6ceb92ed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceb92ed",
  null
  
)

export default component.exports